import { render, staticRenderFns } from "./NotificacaoMensagemMenu.vue?vue&type=template&id=5633f8c0&scoped=true"
import script from "./NotificacaoMensagemMenu.vue?vue&type=script&lang=js"
export * from "./NotificacaoMensagemMenu.vue?vue&type=script&lang=js"
import style0 from "./NotificacaoMensagemMenu.vue?vue&type=style&index=0&id=5633f8c0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5633f8c0",
  null
  
)

export default component.exports